// Product Master V2 (iter24) — grouping helpers shared by every catalog
// renderer (SharedCatalogPage, CatalogPreviewModal, FlipbookPage).
//
// The backend hydration attaches `_group` metadata + `_group_siblings` (the
// full active SKU roster) to every product that belongs to a Design Group.
// Standalone products do not carry these fields.
//
// Renderers must:
//   - render exactly ONE card per design_group_id per section (first occurrence wins),
//   - skip subsequent siblings within the same section,
//   - fall back to the standalone card layout for products without a group.
//
// `iterateSectionCards(products)` yields a de-duplicated list of "cards" the
// renderer can iterate with a single .map().

export function iterateSectionCards(products) {
  const seen = new Set();
  const cards = [];
  (products || []).forEach((p, idx) => {
    const gid = p?.design_group_id;
    const siblings = p?._group_siblings || [];
    const isGroup = Boolean(gid && siblings.length > 0);
    if (isGroup) {
      if (seen.has(gid)) return; // sibling already rendered as the group card
      seen.add(gid);
    }
    cards.push({ product: p, isGroup, idx });
  });
  return cards;
}

// Convenience helpers for pulling display fields off either kind of card.
export const cardCode = ({ product, isGroup }) =>
  isGroup ? product?._group?.code || product?.product_code : product?.product_code;

export const cardName = ({ product, isGroup }) =>
  isGroup ? product?._group?.name || product?.product_name : product?.product_name;

export const cardShort = ({ product, isGroup }) =>
  isGroup ? product?._group?.short_description || product?.short_description : product?.short_description;

export const cardImage = ({ product, isGroup }) =>
  (isGroup && product?._group?.image) || product?.cover_image || '';
